import "../../style.css";
import "../user-area.css";
import "./profil.css";
import Cookies from "universal-cookie";
import React, { useEffect, useState } from "react";
import { API_URL } from "../../../api";
import Banner from "../../../components/banner/Banner";

const Nastavitve = ({ data }) => {
	try {
		var user = data.verification.verified;
	} catch {
		var user = false;
	}
	const [disableSent, setDisableSent] = useState(user);
	const [verificationStatus, setVerificationStatus] = useState(user);
	const [codeBox, setCodeBox] = useState(user);
	const [verificationCode, setVerificationCode] = useState("");
	const [verificationMessage] = useState("");
	const [verifyButtonVisibility, setVerifyButtonVisibility] = useState(
		data.verification.sent
	);
	const [spremeniEmail, setChangeEmail] = useState(false);
	const [newEmail, setNewEmail] = useState("");
	const [enteredUsername, checkUsername] = useState("");
	const [newMessage, setNewMessage] = useState("");
	const [changeBanner, setBannerTrue] = useState(false);
	const [deleteConfirmation] = useState(false);
	const [setShowPopup] = useState(false);
	const [setPopupMessage] = useState("");

	const DeleteAccount = () => {
		if (!deleteConfirmation) {
			setPopupMessage(
				"Please retype your username to confirm account deletion."
			);
			setShowPopup(true);
			return;
		}
	};
	const DeleteAccount2 = () => {
		if (data.username === enteredUsername) {
			const cookies = new Cookies();
			let sessionToken = cookies.get("sessionToken");
			fetch(
				`${API_URL}/api/DeleteAccount?token=${encodeURIComponent(
					sessionToken
				)}`
			)
				.then((response) => response.json())
				.then((data) => {
					const message = "Račun je bil uspešno izbrisan!";
					cookies.remove("sessionToken", { path: "/" });
					cookies.set("message", message, { path: "/" });
					cookies.set("banner", true, { path: "/" });
					window.location.reload();
				})
				.catch((error) => {
					console.log(error);
				});
		} else {
			setMessage("Uporabniško ime se ne ujema.");
			setShowPopup(false);
			checkUsername("");
		}
	};
	const handleVerifyEmail = () => {
		if (!disableSent) {
			fetch(
				`${API_URL}/api/send_verification_email?username=${encodeURIComponent(
					data.username
				)}&email=${encodeURIComponent(data.email)}`
			)
				.then((response) => response.json())
				.then((result) => {
					if (result === true) {
						setMessage("Uspešno poslano.");
						setVerifyButtonVisibility(true);
						setCodeBox(true);
					} else {
						setMessage(
							"Mail ni poslan. Prosim, obrni se na skrbnika."
						);
					}
				})
				.catch((error) => {
					console.error("Napaka pri pošiljanju:", error);
					setMessage("Napaka pri pošiljanju maila.");
				});
			setDisableSent(true);
		} else {
			setMessage(
				"Mail je bil že poslan. Prosim preverite tudi v neželeni pošti."
			);
		}
	};

	const setMessage = (message) => {
		setNewMessage(message);
		setBannerTrue(true);
		setTimeout(() => {
			setBannerTrue(false);
		}, 4000);
	};

	const setButtonMail = () => {
		const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
		if (spremeniEmail === true) {
			if (!emailRegex.test(newEmail)) {
				setMessage("Neveljaven email.");
			} else {
				try {
					fetch(
						`${API_URL}/api/setEmail?email=${encodeURIComponent(
							data.email
						)}&token=${encodeURIComponent(
							data
						)}&newEmail=${encodeURIComponent(
							newEmail
						)}&username=${encodeURIComponent(data.username)}`
					)
						.then((response) => response.json())
						.then((result) => {
							if (result.status === true) {
								setMessage("Uspešno zamenjan mail.");
							} else {
								setMessage("Mail ni bil zamenjan.");
							}
						})
						.catch((error) => {
							console.error("Napaka:", error);
							setMessage("Napaka pri menjavi maila.");
						});
				} catch (error) {
					setMessage("Pojavila se je napaka.");
				}
			}
		} else {
			setChangeEmail(true);
		}
	};

	const handleVerifyCode = () => {
		// preveri kodo za preverjanje maila
		fetch(
			`${API_URL}/api/verify_code?username=${encodeURIComponent(
				data.username
			)}&code=${encodeURIComponent(verificationCode)}`
		)
			.then((response) => response.json())
			.then((result) => {
				if (result === "true") {
					setVerificationStatus(true);
					setMessage("Email preverjen!");
				} else if (result === "false") {
					setMessage("Napačna koda.");
					setVerificationCode("");
				} else if (result === "expired") {
					setMessage("Koda je pretečena!");
					setVerificationCode("");
				}
			})
			.catch((error) => {
				console.error("Napaka:", error);
				setMessage("Pojavila se je napaka.");
			});
	};

	useEffect(() => {
		// to preveri, če je bil mail preverjen ali ne
		fetch(
			`${API_URL}/api/verification_status?username=${encodeURIComponent(
				data.username
			)}`
		)
			.then((response) => response.json())
			.then((result) => {
				if (result.status === true) {
					setVerificationStatus(true);
				}
				if (result.sent === true) {
					setCodeBox(true);
				}
			})
			.catch((error) => {
				console.error("Napaka pri preverjanju maila:", error);
			});
	}, [data.username]);

	return (
		<div className="main-profile">
			<Banner message={newMessage} banner={changeBanner} />
			{!verificationStatus && (
				<div style={{ color: "red" }}>
					<h3>Obvestilo</h3>
					<p>
						Malica se bo pričela avtomatsko naročati šele, ko boste
						preverili email.
					</p>
				</div>
			)}
			<div className="profile">
				<h2>Profil</h2>
				<div>
					<p>E-mail: {data.email}</p>
					<p>Preverjen e-mail: {verificationStatus ? "Da" : "Ne"}</p>
					<button className="btn change-btn" onClick={setButtonMail}>
						Spremeni e-mail
					</button>
					{spremeniEmail && (
						<>
							<input
								type="text"
								autoComplete="on"
								placeholder="Nov e-mail"
								value={newEmail}
								onChange={(e) => setNewEmail(e.target.value)}
							/>
						</>
					)}
					{!verificationStatus && (
						<>
							<h2>Preverjanje maila</h2>
							{!verifyButtonVisibility && (
								<button
									className="btn"
									onClick={handleVerifyEmail}>
									Pošlji email preverjanje
								</button>
							)}
							{codeBox && (
								<>
									<input
										type="text"
										autoComplete="off"
										placeholder="Vnesi kodo"
										value={verificationCode}
										onChange={(e) =>
											setVerificationCode(e.target.value)
										}
									/>
									<button
										className="btn"
										onClick={handleVerifyCode}>
										Preveri kodo
									</button>
									<p>{verificationMessage}</p>
								</>
							)}
						</>
					)}
				</div>
				<div>
					<h2>Nevarna cona</h2>
					<p>
						Tukaj lahko izbrišete svoj račun. Prosimo, da to storite
						le, če ste prepričani, da tega ne boste obžalovali.
					</p>
					<button onClick={DeleteAccount} className="btn-delete">
						Izbriši račun
					</button>
				</div>
			</div>
		</div>
	);
};
export default Nastavitve;
